import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IExtendedUsuario } from '../../models/IUsuario';

export interface IModuleInfo {
  IdProduto: number
  Nome: string
}

interface IUserState {
  currentUser?: IExtendedUsuario
  modules: IModuleInfo[]
}

const initialState: IUserState = {
  currentUser: undefined,
  modules: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUserState(state, action: PayloadAction<IExtendedUsuario>) {
      state.currentUser = action.payload
    },
    setCurrentUserModulesState(state, action: PayloadAction<IModuleInfo[]>) {
      state.modules = action.payload
    }
  },
});

export const {
  setCurrentUserState,
  setCurrentUserModulesState
} = userSlice.actions;

export const userReducer = userSlice.reducer;